<template>
  <div class="lightbox-book-detail">
    <div class="lightbox-book-detail__inner">
      <h2 class="lightbox-book-detail__ttl">Unlimitedへの加入が完了しました。</h2>
      <p class="lightbox-book-detail__sentence">Unlimited機能がアプリ上でご利用頂けるようになりました。</p>
      <button class="btn-square" @click="keepShopping">ショッピングを続ける</button>
      <a href="https://d1i3iegge9runl.cloudfront.net/" target="_blank" style="text-decoration:none" v-if="isiPhone()"><button class="btn-square btn-square--app">アプリへ移動</button></a>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    computed: {
      nameBook() {
        return this.$store.getters.bookDetail.name_book;
      }
    },
    methods: {
      keepShopping() {
        this.$store.dispatch("hideLightBox");
      },
      isiPhone() {
        const ua = window.navigator.userAgent.toLowerCase();
        return (ua.indexOf('iphone') !== -1 || ua.indexOf('ipod') !== -1 || ua.indexOf('ipad') !== -1)
      }

    }
  }
</script>

<style scoped lang="scss">
  .lightbox-book-detail {
    padding: 0 15px;
    &__inner {
      max-width: 440px;
      margin: 0 auto;
      padding: 10px 15px;
      background-color: #fff;
    }
    &__ttl {
      font-size: 18px;
      font-size: 1.8rem;
      font-weight: bold;
      margin-bottom: 10px;
    }
    &__sentence {
      text-align: justify;
      margin-bottom: 25px;
    }
    .btn-square {
      margin-bottom: 8px;
      &--app {
        color: #fff;
        background-color: #9b9b9b;
        border-color: #919191;
      }
    }
    .book-bottom {
      padding: 20px 0 0;
      a {
        color: #FF5B60;
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lightbox/UnlimitedResult.vue